import { deepFreeze } from '@platform-ui-common/utilities/object.js';
import INTRO_PAGES from './introPages.js';
import QUESTIONS from './questions.js';
import SECTIONS from './sections.js';
import { StandardComponents } from './types.js';

const STANDARD_COMPONENTS: StandardComponents = deepFreeze({
  definitions: {
    introPages: INTRO_PAGES,
    questions: QUESTIONS,
    sections: SECTIONS,
  },
});
export default STANDARD_COMPONENTS;
